import { render, staticRenderFns } from "./newServiceModal.vue?vue&type=template&id=bad2b2ea"
import script from "./newServiceModal.vue?vue&type=script&lang=js"
export * from "./newServiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports